import React from 'react';

function SortArrows(props) {
    const fill = props.fill;
    const className = props.className;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            fill="none"
            className={className}
        >
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M8.35401 5.87548L4.67098 2.19246C4.44497 1.96645 4.07854 1.96645 3.85253 2.19246L0.169507 5.87548C-0.0565021 6.10149 -0.0565023 6.46792 0.169507 6.69393C0.395515 6.91994 0.761948 6.91994 0.987957 6.69393L3.68303 3.99886L3.68302 12.3099C3.68302 12.6295 3.94213 12.8886 4.26176 12.8886C4.58138 12.8886 4.84049 12.6295 4.84049 12.3099L4.84049 3.99886L7.53556 6.69393C7.76156 6.91994 8.128 6.91994 8.35401 6.69393C8.58002 6.46792 8.58002 6.10149 8.35401 5.87548ZM15.8305 10.1248L12.1475 13.8079C11.9215 14.0339 11.555 14.0339 11.329 13.8079L7.64599 10.1248C7.41999 9.89883 7.41999 9.5324 7.64599 9.30639C7.872 9.08038 8.23844 9.08038 8.46444 9.30639L11.1595 12.0015L11.1595 3.69042C11.1595 3.37079 11.4186 3.11169 11.7382 3.11169C12.0579 3.11169 12.317 3.37079 12.317 3.69042L12.317 12.0015L15.012 9.30639C15.2381 9.08038 15.6045 9.08038 15.8305 9.30639C16.0565 9.5324 16.0565 9.89883 15.8305 10.1248Z" 
                fill={fill}
            />
        </svg>
    )
};

export default SortArrows;